/* eslint-disable react/prop-types */
import React from 'react';
import ReferralLink from './ReferralLink';
import messages from '../../../messages';

const ForgotPwLink = ({username, prefix}) => (
  <ReferralLink
    link="/user/forgot-password/"
    username={username}
    prefix={prefix || messages.get('user.forgotPwLink.prefix')}
    linkText={messages.get('user.forgotPwLink.linkText')}
    suffix={messages.get('user.forgotPwLink.suffix')}
  />
);

export default ForgotPwLink;
